export default class Requests {
    private baseUrl: string;
  
    constructor(baseUrl: string = process.env.NEXT_PUBLIC_SERVER_URL!) {
      this.baseUrl = baseUrl;
    }
  
    private getFullUrl(endpoint: string): string {
      // If endpoint is already an absolute URL, return it as is
      if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
        return endpoint;
      }
      
      // Ensure baseUrl doesn't end with slash and endpoint starts with slash
      const base = (this.baseUrl || '').replace(/\/+$/, "");
      const path = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
      return `${base}${path}`;
    }
  
    async get(endpoint: string, options: any = {}) {
      const url = this.getFullUrl(endpoint);
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
        ...options,
      });
  
      return await response.json();
    }
  
    async post(
      endpoint: string,
      data: any = {},
      options: any = {}
    ) {
      const url = this.getFullUrl(endpoint);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
        body: JSON.stringify(data),
        ...options,
      });
  
      return await response.json();
    }
  }
  